import apiClient from './client';

export interface PhaseDistribution {
  phase: number;
  count: number;
  percentage: number;
}

export interface TimelineEntry {
  date: string;
  successRate: number;
  totalQuestions: number;
  correctAnswers: number;
}

export interface OverallStats {
  totalAnswers: number;
  correctAnswers: number;
  successRate: number;
  averageTime: number;
}

export interface CourseStatistics {
  phaseDistribution: PhaseDistribution[];
  timeline: TimelineEntry[];
  overall: OverallStats;
}

export interface GlobalCourseStats {
  courseId: number;
  courseName: string;
  totalVocabularies: number;
  learnedVocabularies: number;
  inProgress: number;
  new: number;
  overallProgress: number;
}

export interface ActivityData {
  today: string;
  days: { date: string; count: number }[];
  streak: number;
  record: number;
  learnedToday: boolean;
  lastLearnedAt: string | null;
  due: { total: number; courses: { courseId: number; due: number }[] };
}

export const statisticsApi = {
  /** Returns null when the endpoint is not available (404), so the UI can degrade. */
  getActivity: async (days = 105): Promise<ActivityData | null> => {
    try {
      const tz = -new Date().getTimezoneOffset();
      const { data } = await apiClient.get('/statistics/activity', { params: { tz, days } });
      return data;
    } catch (e: any) {
      if (e?.response?.status === 404) return null;
      throw e;
    }
  },

  getCourseStats: async (courseId: number): Promise<CourseStatistics> => {
    const { data } = await apiClient.get(`/statistics/courses/${courseId}`);
    return data;
  },

  getGlobalStats: async (): Promise<GlobalCourseStats[]> => {
    const { data } = await apiClient.get('/statistics/global');
    return data;
  },
};
